
import { observable, action } from 'mobx';
import { plainToClassFromExist } from 'class-transformer';

import OtherService from '../../service/OtherService/OtherService';
import { IuploadImgParam } from './ParamModel';
/**
 * 获取图片上传临时写权限（阿里云）
 *
 ***/
export class StsWrite {
    @observable public expiration: string;
    @observable public accessKeyId: string;
    @observable public accessKeySecret: string;
    @observable public securityToken: string;
    @observable public endpoint: string;
    @observable public callbackBody: { callbackUrl: string, callbackBody: string, callbackBodyType: string };
    @observable public bucketName: string;
    @observable public signature: string;
    @observable public host: string;
    @observable public policy: string;
    @observable public fileLevel: number;
    @observable public region: string;
    @observable public folderPrefix: string;
    @observable public storageType: string;
    @action public init() {
        return OtherService.getStsWrite().then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// 获取读百度bos图片信息
export class StsRead {
  public imageSize: { value: string };
  public Format: { value: string };
  public imageHeight: { value: string };
  public imageWidth: { value: string };
  @action public init(file) {
      return OtherService.getStsRead(file).then((res) => {
          plainToClassFromExist(this, res);
          return res;
      });
  }
}

// 获取视频临时上传权限（阿里云vod）

export class StsUpload {
    @observable public expiration: string;
    @observable public accessKeyId: string;
    @observable public accessKeySecret: string;
    @observable public securityToken: string;
    @observable public endpoint: string;
    @observable public callbackBody: { callbackUrl: string, callbackBody: string, callbackBodyType: string };
    @observable public bucketName: string;
    @observable public signature: string;
    @observable public host: string;
    @observable public policy: string;
    @observable public fileLevel: number;
    @observable public region: string;
    @observable public folderPrefix: string;
    @observable public storageType: string;
    @action public init() {
        return OtherService.getStsVodUpload().then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// 申请临时授权-查询截图数据

export class Snapshots {
    @action public init(videoId) {
        return OtherService.getSnapshots(videoId).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }

}

// 申请临时授权-查询视频数据
export class PlayInfo {
    @action public init(videoId) {
        return OtherService.getPlayInfo(videoId).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}
// 图片上传
export class UploadImg {
    @action public init(param: IuploadImgParam) {
        return OtherService.uploadImg(param).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// 获取阿里云图片信息
export class GetImgInfoModel {
    public FileSize: { value: string };
    public Format: { value: string };
    public ImageHeight: { value: string };
    public ImageWidth: { value: string };
    @action public init(imgUrl: string) {
        return OtherService.GetImgInfo(imgUrl).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }

}
// 获取百度bos图片信息
export class GetBosImgInfoModel {
    public imageSize: { value: string };
    public Format: { value: string };
    public imageHeight: { value: string };
    public imageWidth: { value: string };
    @action public init(imgUrl: string) {
        return OtherService.GetBosImgInfo(imgUrl).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// 获取百度bos图片信息(新)
export class GetOasBosImgInfoModel {
  public imageSize: { value: string };
  public Format: { value: string };
  public imageHeight: { value: string };
  public imageWidth: { value: string };
  @action public init(file: string) {
      return OtherService.GetStsBosImgInfo(file).then((res) => {
          // plainToClassFromExist(this, res);
          const _this = this
          return OtherService.GetStsBosImgInfoUrl(res.fileUrl).then((data) => {
            plainToClassFromExist(_this, data.data);
            return data
          });
      });
  }
}
